import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import projectList from "../views/projectList";
import workbench from "../views/workbench";
// 照片
import photoList from "../views/photo/list";
import photoUpload from "../views/photo/upload";
// 记事
import notesList from "../views/notes/list";
import notesDetail from "../views/notes/detail";
import notesAdd from "../views/notes/add";
import notesEdit from "../views/notes/edit";
// 质量巡检
import qualityPatrolList from "../views/qualityPatrol/list";
import qualityPatrolAdd from "../views/qualityPatrol/add";
import qualityPatrolDetail from "../views/qualityPatrol/detail";
import qualityPatrolEdit from "../views/qualityPatrol/edit";
import qualityPatrolClose from "../views/qualityPatrol/close";
// 安全巡检
import safePatrolList from "../views/safePatrol/list";
import safePatrolAdd from "../views/safePatrol/add";
import safePatrolDetail from "../views/safePatrol/detail";
import safePatrolEdit from "../views/safePatrol/edit";
import safePatrolClose from "../views/safePatrol/close";
// 质量旁站
import qualitySideStationList from "../views/qualitySideStation/list";
import qualitySideStationAdd from "../views/qualitySideStation/add";
import qualitySideStationEdit from "../views/qualitySideStation/edit";
import qualitySideStationDetail from "../views/qualitySideStation/detail";
// 安全旁站
import safeSideStationList from "../views/safeSideStation/list";
import safeSideStationAdd from "../views/safeSideStation/add";
import safeSideStationEdit from "../views/safeSideStation/edit";
import safeSideStationDetail from "../views/safeSideStation/detail";
// 质量报验
import qualityInspectionList from "../views/qualityInspection/list";
import qualityInspectionAdd from "../views/qualityInspection/add";
import qualityInspectionEdit from "../views/qualityInspection/edit";
import qualityInspectionDetail from "../views/qualityInspection/detail";
import qualityInspectionClose from "../views/qualityInspection/close";
import qualityInspectionRepeat from "../views/qualityInspection/repeat";
// 安全报验
import safeInspectionList from "../views/safeInspection/list";
import safeInspectionAdd from "../views/safeInspection/add";
import safeInspectionEdit from "../views/safeInspection/edit";
import safeInspectionDetail from "../views/safeInspection/detail";
import safeInspectionClose from "../views/safeInspection/close";
import safeInspectionRepeat from "../views/safeInspection/repeat";

const routes = [
	{path: '*',redirect: '/projectList'},
	{path: '/projectList/:appid?/:secretkey?', component: projectList, name: 'projectList', meta: {title: '项目列表'}},
	{path: '/workbench', component: workbench, name: 'workbench', meta: {title: '工作台'}},
	
	{path: '/photoList', component: photoList, name: 'photoList', meta: {title: '照片列表'}},
	{path: '/photoUpload', component: photoUpload, name: 'photoUpload', meta: {title: '照片上传'}},
	
	{path: '/notesList', component: notesList, name: 'notesList', meta: {title: '记事列表'}},
	{path: '/notesDetail', component: notesDetail, name: 'notesDetail', meta: {title: '记事详情'}},
	{path: '/notesAdd', component: notesAdd, name: 'notesAdd', meta: {title: '添加记事'}},
	{path: '/notesEdit', component: notesEdit, name: 'notesEdit', meta: {title: '编辑记事'}},
	// 质量巡检
	{path: '/qualityPatrolList', component: qualityPatrolList, name: 'qualityPatrolList', meta: {title: '巡检列表'}},
	{path: '/qualityPatrolAdd', component: qualityPatrolAdd, name: 'qualityPatrolAdd', meta: {title: '新增巡检'}},
	{path: '/qualityPatrolDetail', component: qualityPatrolDetail, name: 'qualityPatrolDetail', meta: {title: '巡检详情'}},
	{path: '/qualityPatrolEdit', component: qualityPatrolEdit, name: 'qualityPatrolEdit', meta: {title: '编辑巡检'}},
	{path: '/qualityPatrolClose', component: qualityPatrolClose, name: 'qualityPatrolClose', meta: {title: '巡检问题封闭'}},
	// 安全巡检
	{path: '/safePatrolList', component: safePatrolList, name: 'safePatrolList', meta: {title: '巡检列表'}},
	{path: '/safePatrolAdd', component: safePatrolAdd, name: 'safePatrolAdd', meta: {title: '新增巡检'}},
	{path: '/safePatrolDetail', component: safePatrolDetail, name: 'safePatrolDetail', meta: {title: '巡检详情'}},
	{path: '/safePatrolEdit', component: safePatrolEdit, name: 'safePatrolEdit', meta: {title: '编辑巡检'}},
	{path: '/safePatrolClose', component: safePatrolClose, name: 'safePatrolClose', meta: {title: '巡检问题封闭'}},
	// 质量旁站
	{path: '/qualitySideStationList', component: qualitySideStationList, name: 'qualitySideStationList', meta: {title: '旁站列表'}},
	{path: '/qualitySideStationAdd', component: qualitySideStationAdd, name: 'qualitySideStationAdd', meta: {title: '新增旁站'}},
	{path: '/qualitySideStationEdit', component: qualitySideStationEdit, name: 'qualitySideStationEdit', meta: {title: '编辑旁站'}},
	{path: '/qualitySideStationDetail', component: qualitySideStationDetail, name: 'qualitySideStationDetail', meta: {title: '旁站详情'}},
	// 安全旁站
	{path: '/safeSideStationList', component: safeSideStationList, name: 'safeSideStationList', meta: {title: '旁站列表'}},
	{path: '/safeSideStationAdd', component: safeSideStationAdd, name: 'safeSideStationAdd', meta: {title: '新增旁站'}},
	{path: '/safeSideStationEdit', component: safeSideStationEdit, name: 'safeSideStationEdit', meta: {title: '编辑旁站'}},
	{path: '/safeSideStationDetail', component: safeSideStationDetail, name: 'safeSideStationDetail', meta: {title: '旁站详情'}},
	
	// 质量报验
	{path: '/qualityInspectionList', component: qualityInspectionList, name: 'qualityInspectionList', meta: {title: '报验列表'}},
	{path: '/qualityInspectionAdd', component: qualityInspectionAdd, name: 'qualityInspectionAdd', meta: {title: '新增报验'}},
	{path: '/qualityInspectionEdit', component: qualityInspectionEdit, name: 'qualityInspectionEdit', meta: {title: '编辑报验'}},
	{path: '/qualityInspectionDetail', component: qualityInspectionDetail, name: 'qualityInspectionDetail', meta: {title: '报验详情'}},
	{path: '/qualityInspectionClose', component: qualityInspectionClose, name: 'qualityInspectionClose', meta: {title: '关闭报验'}},
	{path: '/qualityInspectionRepeat', component: qualityInspectionRepeat, name: 'qualityInspectionRepeat', meta: {title: '再次报验'}},
	
	// 安全报验
	{path: '/safeInspectionList', component: safeInspectionList, name: 'safeInspectionList', meta: {title: '报验列表'}},
	{path: '/safeInspectionAdd', component: safeInspectionAdd, name: 'safeInspectionAdd', meta: {title: '新增报验'}},
	{path: '/safeInspectionEdit', component: safeInspectionEdit, name: 'safeInspectionEdit', meta: {title: '编辑报验'}},
	{path: '/safeInspectionDetail', component: safeInspectionDetail, name: 'safeInspectionDetail', meta: {title: '报验详情'}},
	{path: '/safeInspectionClose', component: safeInspectionClose, name: 'safeInspectionClose', meta: {title: '关闭报验'}},
	{path: '/safeInspectionRepeat', component: safeInspectionRepeat, name: 'safeInspectionRepeat', meta: {title: '再次报验'}},
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
export default router
